import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SorryPage } from 'src/app/pages/sorry/sorry.page';

import { ConfigPage } from './config.page';

const routes: Routes = [
  {
    path: ':cnpj/:mode',
    component: ConfigPage
  },
  // {
  //   path: ':cnpj/:mode/:cardStyle',
  //   component: ConfigPage
  // },
  {
    path: ':cnpj/:mode/:tableNumber',
    component: ConfigPage
  },
  // {
  //   path: ':cnpj/:mode/:cardStyle/:tableNumber',
  //   component: ConfigPage
  // },
  {
    path: '**',
    component: SorryPage
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConfigPageRoutingModule {}
